// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
import { createBrowserHistory } from 'history';

import { showConfirmation } from '@shared/components/Confirmation';

export default createBrowserHistory({
  getUserConfirmation: (message, callback): void => {
    showConfirmation({ title: 'Unsaved changes', question: message }, callback);
  }
});